//@flow
import React from 'react';
import {makeStyles, Typography} from '@material-ui/core';
import {colors} from '../../assets/styles/colors';
import type {TemplateBodyComponent as BodyType} from '../../entities/multichat/whatsapp-api';

type TemplateVariable = {
  id: string,
  scope: 'HEADER' | 'BODY',
  name?: string,
  position?: number,
  value: string,
};

type Props = {
  component: BodyType,
  variables: TemplateVariable[],
  showTemplate: boolean,
};

const useStyles = makeStyles(() => ({
  text: {
    fontSize: '13px',
    color: colors.grey900,
    whiteSpace: 'pre-wrap',
  },
}));

const interpolateText = (
  templateText: string,
  variables: TemplateVariable[]
): React.Node => {
  if (!templateText) return templateText;

  const parts = templateText.split(/({{[\w-]+}})/);

  return parts.map((part, index) => {
    const match = part.match(/{{([\w-]+)}}/);
    console.log({match});
    if (match) {
      const variable = variables.find(v => v.name === match[1]);

      const value = variable?.value || part;

      return (
        <span
          key={index}
          style={{
            color: colors.primary,
            fontWeight: 'bold',
          }}
        >
          {value}
        </span>
      );
    }
    return <span key={index}>{part}</span>;
  });
};

export default function TemplateBodyComponent({
  component,
  variables,
  showTemplate,
}: Props) {
  const classes = useStyles();

  if (!component.text) return null;

  if (showTemplate) {
    return (
      <Typography className={classes.text}>
        {interpolateText(component.text, [])}
      </Typography>
    );
  }

  const bodyVariables = variables.filter(v => v.scope === 'BODY');

  return (
    <Typography className={classes.text}>
      {interpolateText(component.text, bodyVariables)}
    </Typography>
  );
}
